import { render, staticRenderFns } from "./Spinners.vue?vue&type=template&id=2926bd58&scoped=true"
import script from "./Spinners.vue?vue&type=script&lang=js"
export * from "./Spinners.vue?vue&type=script&lang=js"
import style0 from "spinkit/scss/spinkit.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Spinners.vue?vue&type=style&index=1&id=2926bd58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2926bd58",
  null
  
)

export default component.exports